import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import {
  ESubscriptionAction,
  EBillingTaskStatus,
  EBillingTaskType,
} from '../../enums';
import {
  IsDate,
  IsEnum,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
} from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

import { EAcquirerService } from './task.enums';

export { EAcquirerService } from './task.enums';

export class SubscriptionTaskData {
  @ApiProperty()
  @IsString()
  entityName: string;

  @ApiProperty()
  @IsNumber()
  entityId: number;

  @IsString()
  @IsOptional()
  acquirerSubscriptionId?: string;

  @ApiProperty()
  @IsOptional()
  @IsString()
  action: ESubscriptionAction;

  @ApiProperty()
  @IsOptional()
  @IsNumber()
  discount?: number;

  @ApiProperty()
  @IsOptional()
  @IsNumber()
  after?: Date;

  @IsString()
  @IsOptional()
  returnUrl?: string;

  @ApiProperty()
  @IsNumber()
  days: number;

  @ApiProperty()
  @IsNumber()
  previousPlan: number;

  @ApiProperty()
  @IsString()
  planName: string;
}

@Index('billing__task__acquirer_id', ['acquirer', 'acquirerTaskId'], {
  unique: true,
  where: `"acquirerTaskId" <> ''`,
})
export class BillingTask extends BasicEntity {
  @Column({ type: 'int', nullable: true })
  accountId: number;

  @ApiProperty()
  @IsString()
  @Column({ type: 'varchar', nullable: false, default: '' })
  source: string;

  @ApiProperty()
  @IsObject()
  @Column({ type: 'jsonb', nullable: false, default: {} })
  context: SubscriptionTaskData;

  @ApiProperty()
  @IsNumber()
  @Column({ type: 'int', nullable: false, default: 0 })
  // price in cents
  price: number;

  @ApiProperty()
  @IsEnum(EBillingTaskType)
  @Column({
    type: 'int',
    nullable: false,
    enum: EBillingTaskType,
    default: EBillingTaskType.coinsPurchase,
  })
  billingTaskType: EBillingTaskType;

  @ApiProperty()
  @IsNumber({})
  @Column({ type: 'int', nullable: false, default: 0 })
  billingPacket: number;

  @ApiProperty()
  @IsNumber({})
  @Column({ type: 'int', nullable: false, default: 0 })
  pricePerOne: number; // unit price in cents or kopecks

  @ApiProperty({ required: false })
  @IsNumber({})
  @IsOptional()
  @Column({ type: 'int', nullable: false, default: 1 })
  quantity: number; // full price calculation: pricePerOne * quantity - discount

  @ApiProperty()
  @IsNumber({})
  @Column({ type: 'int', nullable: false, default: 0 })
  @IsNumber()
  coins: number;

  @ApiProperty()
  @IsEnum(EBillingTaskStatus)
  @Column({
    type: 'int',
    nullable: false,
    default: EBillingTaskStatus.created,
    enum: EBillingTaskStatus,
  })
  status: EBillingTaskStatus;

  @Column({
    type: 'int',
    nullable: false,
    default: EAcquirerService.unknown,
    enum: EAcquirerService,
  })
  acquirer: EAcquirerService;

  @Column({ type: 'varchar', nullable: false, default: '' })
  acquirerTaskId: string;

  @Column({ type: 'jsonb', nullable: true })
  request: unknown;

  @Column({ type: 'jsonb', nullable: true })
  response: unknown;

  @Column({ type: 'jsonb', nullable: true })
  result: unknown;

  @Column({ type: 'jsonb', nullable: true })
  error: unknown;

  @ApiProperty()
  @IsDate()
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  startedAt: Date;

  @ApiProperty()
  @IsDate()
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  finishedAt: Date;
}
